module.exports = "pegasus_template/assets/email1-logo.png";